<template>
  <div class="card-slider">
    <TransitionGroup
      ref="cardSliderTrack"
      tag="div"
      class="card-slider__track"
      name="card-slider"
      :style="{ height }"
    >
      <article
        v-for="{ title, text, ...slide } in activeSlides"
        :key="title"
        class="card-slider__item"
      >
        <Image v-if="slide.image" :source="slide.image" class="card-slider__image" />

        <div class="card-slider__content">
          <h4 class="card-slider__title">{{ title }}</h4>
          <RawHtml :html="text" />
        </div>
      </article>
    </TransitionGroup>

    <nav class="card-slider__nodes">
      <button
        v-for="index in slides.length"
        :key="index"
        class="card-slider__goto"
        @click="handleGoToClick(index - 1)"
      />

      <span class="card-slider__goto -active" :style="activeNodeStyle" />

      <nav class="card-slider__menu">
        <button :class="getButtonClassName()" @click="shiftSlide">
          <Icon id="arrow" />
        </button>

        <button :class="getButtonClassName(true)" @click="unshiftSlide">
          <Icon id="arrow" />
        </button>
      </nav>
    </nav>
  </div>
</template>

<script>
import Icon from '@/components/global/Icon.vue'
import Image from '@/components/global/Image.vue'
import RawHtml from '@/components/global/RawHtml.vue'

export default {
  name: 'CardSlider',
  components: { Image, Icon, RawHtml },
  props: {
    slides: { type: Array, default: Array },
    imageKey: { type: String, default: null },
  },
  data() {
    return {
      height: 'auto',
      activeSlides: [],
      standbySlides: [],
    }
  },
  computed: {
    currentSlideIndex() {
      return this.slides.length - this.activeSlides.length
    },
    activeNodeStyle() {
      return { transform: `translate3d(${this.currentSlideIndex * 2.25}rem, 0, 0)` }
    },
  },
  watch: {
    slides: {
      immediate: true,
      handler(slides) {
        this.activeSlides = [...slides]
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.height = `${this.$refs.cardSliderTrack.$el.clientHeight}px`
    })
  },
  methods: {
    shiftSlide() {
      this.standbySlides.unshift(this.activeSlides.shift())
    },
    unshiftSlide() {
      this.activeSlides.unshift(this.standbySlides.shift())
    },
    handleGoToClick(index) {
      const slideCountDiff = this.activeSlides.length - (this.slides.length - index)

      if (slideCountDiff < 0)
        this.activeSlides.unshift(...this.standbySlides.splice(0, slideCountDiff * -1))
      else this.standbySlides.unshift(...this.activeSlides.splice(0, slideCountDiff))
    },
    getButtonClassName(isPrev) {
      return [
        'card-slider__button',
        {
          '-prev': isPrev,
          '-disabled': isPrev ? !this.standbySlides.length : this.activeSlides.length <= 1,
        },
      ]
    },
  },
}
</script>
